<script>


export default {
    name: 'NavBar',
    methods: {
        scrollToSection(sectionId) {
            const section = document.getElementById(sectionId);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }
}
</script>
<template>
    <v-layout class="d-flex d-sm-none">
        <v-app-bar scroll-behavior="hide" scroll-threshold="100">
            <v-app-bar-title><v-img width="200" src="/img/logotipo.svg"></v-img></v-app-bar-title>
            <v-menu>
                <template v-slot:activator="{ props }">
                    <v-app-bar-nav-icon v-bind="props"></v-app-bar-nav-icon>
                </template>
                <v-list>
                    <v-list-item>
                        <v-list-item-title>
                            <router-link class="cta_nav" to="/">Home</router-link>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title><router-link class="cta_nav"
                                to="/#services">Services</router-link></v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title><router-link class="cta_nav"
                                to="/#projects">Projects</router-link></v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title> <v-btn class="cta_nav wp_icon" icon target="_blank" rel="noreferer noopener"
                                href="https://api.whatsapp.com/send?phone=+573174361131&text=Hola%20QuillQuest,%20necesito%20de%20tu%20ayuda%20con:%20">
                                <v-icon>mdi-whatsapp</v-icon>
                            </v-btn></v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
    </v-layout>
    <v-layout class="rounded rounded-md d-none d-sm-flex">

        <v-app-bar class="d-none d-sm-flex" scroll-threshold="24">
            <v-app-bar-title><v-img width="200" src="/img/logotipo.svg"></v-img></v-app-bar-title>
            <template v-slot:append>
                <router-link class="cta_nav" to="/">Home</router-link>
                <router-link class="cta_nav" to="/#services">Services</router-link>
                <router-link class="cta_nav" to="/#projects">Projects</router-link>
                <v-btn class="cta_nav wp_icon" icon target="_blank" rel="noreferer noopener"
                    href="https://api.whatsapp.com/send?phone=+573174361131&text=Hola%20QuillQuest,%20necesito%20de%20tu%20ayuda%20con:%20">
                    <v-icon>mdi-whatsapp</v-icon>
                </v-btn>
            </template>
        </v-app-bar>

    </v-layout>
</template>
